import React, { useRef } from "react";
import emailjs from "emailjs-com";
// import React from 'react';
import { Form, Row } from "react-bootstrap";

const Contuct = () => {
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_t0fc6il",
        "template_qgyjiap",
        e.target,
        "user_YI9QFdJFluEby1kXk8Uw6"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };

  return (
    <div id="contuct" className="py-5 bg-dark" >
      <h1  className="text-center"style={{ color: "#ffa500" }}>
        Contact Me
      </h1>

      <div className="container">
        <div className="row">
          <div className="col-sm-12  col-md-2">
          </div>

          <div className="col-sm-12  col-md-8">
            <div className="container pt-3">
              <div className="row">
                <div className="col-sm-12 col-md-4">
                  <i style={{ color: "#ffa500" }} className="far fw-bold fa-envelope"></i>
                  <p className="text-white">ronymiah2121@gmail.com</p>
                </div>
                <div className="col-sm-12 col-md-4">
                  <i style={{ color: "#ffa500" }} className="fas fw-bold fa-map-marker-alt"></i>
                  <p className="text-white">Tangail, Dhaka , Bangladesh</p>
                </div>
                <div className="col-sm-12 col-md-4">
                  <i style={{ color: "#ffa500" }} className="fas  fw-bold fa-phone"></i>
                  <p className="text-white">+8801621906353</p>
                </div>
              </div>
            </div>

            <Form onSubmit={sendEmail} className="py-5">
              <Form.Group
                className="mb-3 "
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label className="text-white">Enter Your Name </Form.Label>
                <Form.Control type="text" name="name" placeholder="Name" />
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label className="text-white">Email address</Form.Label>
                <Form.Control type="email" name="email" placeholder="Email" />
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label className="text-white">Message</Form.Label>
                <Form.Control
                  as="textarea"
                  name="message"
                  placeholder="Message....."
                  rows={3}
                />
              </Form.Group>
              <button className="btn btn- " style={{backgroundColor:'#ffa500'}}> Send Message.</button>
            </Form>
          </div>

          <div className="col-sm-12  col-md-2 ">
            {/* One of three columns */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contuct;
